import type { PropsWithChildren } from 'react'

import { MessageHistoryFilterProvider } from '@/modules/log-of-all-messages/use-message-history-filter.tsx'
import { PaginationProvider } from '@/utils/pagination/pagination-context.tsx'

export const MessageHistoryModule = ({ children }: PropsWithChildren) => {
  return (
    <PaginationProvider>
      <MessageHistoryFilterProvider>{children}</MessageHistoryFilterProvider>
    </PaginationProvider>
  )
}
